import React, { useEffect, useState } from "react";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import { TableContainer, Table, TableCell, TableHead, TableBody, TableRow, Paper } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import HideDomainModal from "./HideDomainModal";
import domainService from "../../services/domainService";
import companyService from "../../services/companyService";

const DomainsTable = (props) => {
	
	let [ domains, setDomains ] = useState(domainService.Domains());
	let [ hideDomain, setHideDomain ] = useState(null);
	
	useEffect(() => {
		companyService.onSelectCompany(() => {
			setDomains(domainService.Domains());
		});
	}, []);
	
	// HIDE DOMAIN
	const handleHideDomainClick = (domain) => {
		setHideDomain(domain);
	};
	
	const handleShowDomainClick = (domain) => {
		domain.hidden = false;
		domainService.updateDomain(domain)
		.then(() => {
			setDomains(domainService.Domains());
		})
		.catch((err) => {
			console.log(err.message);
		})
		.finally(() => {
			props.onDomainsChanged();
		});
	};
	
	const handleHideDomainClose = () => {
		setHideDomain(null);
	};
	
	const handleHideDomainSubmit = (domain) => {
		domain.hidden = true;
		domainService.updateDomain(domain)
		.then(() => {
			setDomains(domainService.Domains());
		})
		.catch((err) => {
			console.log(err.message);
		})
		.finally(() => {
			setHideDomain(null);
			props.onDomainsChanged();
		});
	};
	
	return (
		<Stack sx={{ width: "80%", margin: "1em auto" }}>
			<TableContainer component={Paper}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ textAlign: "left" }}>Domain</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Subdomains</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Visible</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{domains? domains.map((domain, index) => (
							<TableRow key={`domain_${index}`}>
								<TableCell sx={{ textAlign: "left", width: "80%" }}>
									<Typography>{`${domain.address}`}</Typography>
								</TableCell>
								<TableCell sx={{ textAlign: "center", width: "10%" }}>
									<Tooltip title={domain.subdomains? (<React.Fragment>
										{domain.subdomains.map((subdomain, i) => {
											if (i === 10) return (
												<Typography key={`sub_elipses`}>
													...
												</Typography>
											)
											else if (i > 10) return null;
											return (
												<Typography key={`sub_${subdomain}.${domain.address}`}>
													{subdomain}.{domain.address}
												</Typography>
											)
										})}
									</React.Fragment>) : ""}>
										<Typography>{`${domain.subdomains.length}`}</Typography>
									</Tooltip>
								</TableCell>
								{ domain.hidden?
									<TableCell sx={{ textAlign: "center", width: "10%" }}>
										<Tooltip title={domain.hiddenReason}>
											<Button onClick={() => {handleShowDomainClick(domain)}}>
												<VisibilityOff/>
											</Button>
										</Tooltip>
									</TableCell>
								:
									<TableCell sx={{ textAlign: "center", width: "10%" }}>
										<Button onClick={() => {handleHideDomainClick(domain)}}>
											<Visibility/>
										</Button>
									</TableCell>
								}
							</TableRow>
						)):<TableRow></TableRow>}
					</TableBody>
				</Table>
			</TableContainer>
			<HideDomainModal
				domain={hideDomain}
				onClose={handleHideDomainClose}
				onSubmit={handleHideDomainSubmit}
			/>
		</Stack>
	);
}

export default DomainsTable;